module.exports = __webpack_public_path__ + "static/img/about-3.1fc6687.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/about-3.png
// module id = 24RB
// module chunks = 1